export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ADS;

export const gtmVirtualPageView = (
  rest,
  itemId,
  itemName,
  itemQty,
  itemValue,
  userEmail,
  userPhone,
  userName,
  userAddress
) => {
  dataLayer.push({
    event: "purchase",
    ecommerce: {
      ...rest,
      // transaction_id: transaction,
      // value: value,
      // currency: "BRL",
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          quantity: itemQty,
          price: itemValue
        }
      ],
      user: [
        {
          email: userEmail,
          phone: userPhone,
          name: userName,
          // surname: "",
          address: userAddress
        }
      ]
    }
  });
};

export const addToCart = (rest, itemId, itemName, itemQty, itemValue) => {
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      ...rest,
      // transaction_id: transaction,
      // value: value,
      // currency: "BRL",
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          quantity: itemQty,
          price: itemValue
        }
      ]
    }
  });
};

export const addShippingInfo = (rest, items) => {
  dataLayer.push({
    event: "add_shipping_info",
    ...rest,
    ecommerce: {
      items: [
        {
          ...items
        }
      ]
    }
  });
};

export const addBeginCheckout = (rest, items, userEmail, userPhone, userName, userAdress) => {
  dataLayer.push({
    event: "begin_checkout",
    ...rest,
    ecommerce: {
      // transaction_id: transaction,
      // value: value,
      // currency: "BRL",
      ...items,
      user: [
        {
          email: userEmail,
          phone: userPhone,
          name: userName,
          address: userAdress
        }
      ]
    }
  });
};

export const addPaymentInfo = (
  rest,
  items,
  userEmail,
  userPhone,
  userName,
  userAdress,
  paymentType
) => {
  dataLayer.push({
    event: "add_payment_info",
    ...rest,

    ecommerce: {
      payment_type: paymentType,
      // transaction_id: transaction,
      // value: value,
      // currency: "BRL",
      ...items,
      user: [
        {
          email: userEmail,
          phone: userPhone,
          name: userName,
          address: userAdress
        }
      ]
    }
  });
};

export const addViewCart = (rest, items) => {
  dataLayer.push({
    event: "view_cart",
    ...rest,
    ecommerce: {
      items: [
        {
          ...items
        }
      ]
    }
  });
};

export const addViewItem = (rest, itemId, itemName, itemQty, itemValue) => {
  dataLayer.push({
    event: "view_item",
    ecommerce: {
      ...rest,
      // transaction_id: transaction,
      // value: value,
      // currency: "BRL",
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          quantity: itemQty,
          price: itemValue
        }
      ]
    }
  });
};

export const addViewItemList = (searchTerm) => {
  dataLayer.push({
    event: "view_item_list",
    ecommerce: {
      search_term: searchTerm
    }
  });
};
